import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/Card';
interface PlaceholderPageProps {
  title: string;
}
export function PlaceholderPage({
  title
}: PlaceholderPageProps) {
  return <div className="w-full h-full" data-id="element-109">
      <Card data-id="element-110">
        <CardHeader data-id="element-111">
          <CardTitle className="text-2xl" data-id="element-112">{title}</CardTitle>
          <CardDescription data-id="element-113">Full content in next prompt.</CardDescription>
        </CardHeader>
        <CardContent data-id="element-114">
          <div className="h-64 border-2 border-dashed border-muted rounded-lg flex items-center justify-center text-muted-foreground" data-id="element-115">
            Placeholder for {title}
          </div>
        </CardContent>
      </Card>
    </div>;
}